<template>
    <div class="upcomming_calendar">
      <FullCalendar ref="fullCalendar" :options='calendarOptions' >
        <template v-slot:eventContent='arg'>
          <div
            class="event_content"
            :style="{ backgroundColor: arg.event.backgroundColor, border: '1px solid ' + arg.event.borderColor }"
            @click="viewEvent(arg.event)"
          >
              <div class="event_title">
                <p>{{ arg.event.title }}</p>
                <p>{{arg.event.extendedProps.times.start_time_24h}} - {{arg.event.extendedProps.times.end_time_24h}}</p>
              </div>
              <!-- <button @click.stop="editEvent(arg.event)">✏️ Edit</button> -->
              <!-- <button @click.stop="deleteEvent(arg.event)">🗑️ Delete</button> -->
          </div>
        </template>
      </FullCalendar>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction';
import { mapGetters } from 'vuex';
import helperMixin from 'shared/mixins/helperMixin';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: {
    FullCalendar,
  },
  mixins:[helperMixin,alertMixin],
  props: {
    events: {
      type: Array,
      required: true,
      default: []
    }
  },
  data: function() {
    return {

    }
  },
  computed:{
    ...mapGetters({
      meetings: "meetings/getMeetings",
      uiFlags: "meetings/getUIFlags",
    }),
    calendarOptions(){
      const formatedEvents = this.events.map(el=>{
        // const start = new Date(this.removeTimeZoneFromDateSting(el.meeting_time));
        const start = new Date(el.friendly_time);
        const end = new Date(start.getTime() + el.duration * 60000); // 60000 ms = 1 min
        const times = this.formatStartEndDate(start,end);

        return {
          ...el,
          start,
          end,
          backgroundColor: el.color,
          borderColor: el.color,
          totalTime: el.duration,
          times,
          // we can add more here. check viewEvent(event)
        }
      })

      return {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
        ],
        initialView: 'dayGridMonth',
        weekends: true,
        allDaySlot: false,
        headerToolbar: {
          left: 'prev,next',
          center: 'title',
          // right: 'dayGridMonth,dayGridWeek,dayGridDay,timeGridWeek,timeGridDay'
          right: 'dayGridYear,dayGridMonth,timeGridWeek,timeGridDay' // user can switch between the two
        },
        // views: {
        //   timeGridSevenDay: {
        //     type: 'timeGrid',
        //     duration: { days: 7 }
        //   }
        // },
        events: [
          ...formatedEvents,
          // {
          //   title: 'Meeting with Team',
          //   start: '2025-04-29T10:00:00',
          //   end: '2025-04-29T11:30:00',
          // },
        ],
        // slotDuration: '01:00:00',       // <-- this sets the slot interval
        // slotLabelInterval: '00:05:00',  // <-- optional: label every 15 mins
        // slotMinTime: '00:00:00',
        // slotMaxTime: '24:00:00',
        // slotMinHeight: 70,
        dayCellContent: function(arg) {
          return { html: `<div class="custom-day">${arg.dayNumberText}</div>` }
        },
        dateClick: this.handleDateClick,
        datesSet: this.handleDatesSet,
        height: 'auto',
        contentHeight: 'auto',
      }
    },
  },
  methods: {
    viewEvent(event) {
      this.$emit('onClickEvent',event);
    },
    editEvent(event) {
      console.log('Editing event:', event);
    },
    deleteEvent(event) {
      console.log('Deleting event:', event);
    },
    handleDateClick(info) {
      // console.log('Cell clicked:', info);
      // console.log('Date clicked:', info.dateStr); // The clicked date
      // console.log('Date object:', info.date); // The full date object
    },
    handleDatesSet(info) {
      // Get the start and end dates of the visible view
      const start_date = info.startStr;  // Start of the view
      const end_date = info.endStr;      // End of the view
      this.$emit('onDateChange',{start_date,end_date})
      // Call your API with the start and end date
      // this.fetchEventsFromAPI(startDate, endDate);
    },
    // end method
  },
}
</script>

<style>

.upcomming_calendar .fc-header-toolbar .fc-col-header{
  margin: 0;
}
.upcomming_calendar .fc-header-toolbar .fc-toolbar-title{
  font-family: 'Figtree', sans-serif;
  line-height: 1.4;
  color: #1F1F1F;
  font-weight: 600;
  font-size: 16px;
}
.upcomming_calendar .fc-header-toolbar .fc-button{
  font-family: 'Figtree', sans-serif;
  line-height: 1.4;
  background-color: #8D25F6;
  border-color: #8D25F6;
}
.upcomming_calendar .fc-header-toolbar .fc-button-active{
  color: #8D25F6 !important;
  background-color: var(--w-30) !important;
  border-color: var(--w-30) !important;
}
/* Handle the active state when clicked */
.upcomming_calendar .fc-header-toolbar .fc-button:active {
  background-color: #8D25F6; /* Keep the background color when pressed */
  border-color: #8D25F6; /* Keep the border color */
  color: white; /* Keep the text color */
}

/* Remove outline when button is focused */
.upcomming_calendar .fc-header-toolbar .fc-button:focus {
  outline: none; /* Remove the outline when focused */
}

.upcomming_calendar .fc-view .fc-day-today{
  background-color: var(--w-30);
  color: #8D25F6;
}

.upcomming_calendar .fc-view .fc-daygrid-month-start{
  font-size: 20px;
}

.upcomming_calendar .fc-view .fc-event{
  color: #fff;
  /* background-color: #8D25F6; */
}
.upcomming_calendar .fc-view .fc-event .event_title{
  display: block;
  width: 100%;
}
.upcomming_calendar .fc-view .fc-event .event_title p{
  margin: 0;
  font-family: 'Figtree', sans-serif;
  line-height: 1.4;
  font-weight: 500;
  font-size: 10px;
  white-space: pre;
}
.upcomming_calendar .event_content{
  width: 100%;
  border-radius: 4px;
  height: 100%;
  overflow: hidden;
}

.upcomming_calendar .fc-timegrid-slot{
  height: 4em;
}

</style>
